var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.626,
    viewBox: "0 0 16 14.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "510864_attachment_office_paperclip_supplies_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M19.874 31.4a5.133 5.133 0 0 1-3.63-8.763l5.863-5.863 1.117 1.117-5.863 5.864a3.554 3.554 0 1 0 5.026 5.026l6.139-6.139a2.177 2.177 0 0 0-3.075-3.083l-5.864 5.861a.8.8 0 1 0 1.131 1.132l5.864-5.864L27.7 21.8l-5.863 5.863a2.379 2.379 0 0 1-3.366-3.363l5.859-5.86a3.757 3.757 0 1 1 5.312 5.313L23.5 29.894a5.1 5.1 0 0 1-3.626 1.506z",
    transform: "translate(-14.743 -16.771)",
    style: {
      fill: "#8e8e8e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/clip_icon.be777a743f7891c6daa04395d0d3ec3b.svg";
export { ForwardRef as ReactComponent };